<template>
  <el-dialog
    :title="
      editRow.type === 'add'
        ? $t('config-manager::operate-config::新增目标')
        : $t('config-manager::operate-config::编辑目标')
    "
    :visible.sync="visible"
    width="500px"
  >
    <div>
      <el-form :model="form" label-width="150px" :rules="rules" ref="form">
        <el-form-item :label="$t('config-manager::operate-config::选择团队')" prop="teamId">
          <el-cascader
            style="width: 250px"
            v-model="form.teamId"
            :options="teams"
            :placeholder="$t('config-manager::operate-config::请选择团队')"
            :props="{ value: 'id', label: 'name', children: 'children', checkStrictly: true }"
            :disabled="editRow.type === 'edit'"
            @change="getWorkers"
          ></el-cascader>
        </el-form-item>
        <el-form-item prop="target">
          <span slot="label">
            {{ $t('config-manager::operate-config::团队目标金额') }}
            <el-tooltip :content="$t('config-manager::operate-config::targetTips')" placement="bottom">
              <i class="icon-a-01wenhao iconfont-el"></i>
            </el-tooltip>
          </span>
          <el-input-number
            style="width: 250px"
            v-model="form.target"
            :placeholder="$t('config-manager::operate-config::targetholder')"
            @change="changeTarget"
            :min="0"
            :max="9999999"
            :precision="2"
            :controls="false"
          >
            <!-- <template slot="append">.00</template> -->
          </el-input-number>
        </el-form-item>
        <el-form-item>
          <span slot="label">
            {{ $t('config-manager::operate-config::员工目标成交额') }}
            <el-tooltip :content="$t('config-manager::operate-config::userTarget')" placement="bottom">
              <i class="icon-a-01wenhao iconfont-el"></i>
            </el-tooltip>
          </span>
        </el-form-item>
        <z-table :columns="columns" :data="workers" :pagination="false" showHeader :maxHeight="450">
          <template #target="{ row }">
            <el-input-number
              v-model="row.target"
              @change="calcTotal"
              :controls="false"
              :min="0"
              :max="9999999"
              :precision="2"
            ></el-input-number>
          </template>
        </z-table>
      </el-form>
    </div>
    <div slot="footer">
      <el-button @click="visible = false">{{ $t('system::common::btn::cancel') }}</el-button>
      <el-button type="primary" @click="submit">{{ $t('system::common::btn::confirm') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getTargetTreeUsers, saveTeamTarget, getTeamTarget } from '@/server/system'
import { teamList } from '@/server/team-manage'
import zzTable from '@/components/ZzTable/zzTable.vue'
export default {
  components: { zzTable },
  data() {
    return {
      visible: false,
      form: {
        teamId: '',
        target: '',
      },
      teams: [],
      workers: [],
      columns: [
        {
          prop: 'loginName',
          label: this.$t('config-manager::operate-config::员工姓名'),
        },
        {
          prop: 'target',
          label: this.$t('config-manager::operate-config::销售额目标'),
        },
      ],
      rules: {
        teamId: [{ required: true, message: this.$t('config-manager::operate-config::请选择团队'), trigger: 'change' }],
        target: [{ required: true, message: this.$t('config-manager::operate-config::teamTarget'), trigger: 'change' }],
      },
    }
  },
  props: {
    value: {},
    editRow: {
      type: Object,
      default: () => {},
    },
    date: String,
  },
  methods: {
    changeTarget() {
      const length = this.workers.length
      this.workers.forEach(item => {
        item.target = (this.form.target / length).toFixed(2)
      })
    },
    async getTargetTreeUsers() {
      const { data } = await teamList({
        pageNum: 1,
        pageSize: 10000,
      })
      if (data.code === this.$code) {
        this.teams = (data.data && this.setTreeData(data.data.items)) || []
      }
    },
    setTreeData(arr) {
      const fn = arr => {
        return arr.map(item => {
          if (item.childrens && item.childrens.length) {
            item.children = fn(item.childrens)
          }
          return item
        })
      }
      return fn(arr)
    },
    async getWorkers() {
      if (this.form.teamId) {
        const { data } = await getTargetTreeUsers({
          teamId: this.form.teamId[this.form.teamId.length - 1],
        })
        if (data.code === this.$code) {
          this.workers = data.data || []
          this.calcTotal()
        }
      }
    },
    calcTotal() {
      let total = 0
      this.workers.forEach(item => {
        total += Number(item.target)
      })
      this.form.target = total
    },
    async submit() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          const { data } = await saveTeamTarget({
            items: this.workers,
            date: this.date,
          })
          if (data.code === this.$code) {
            this.$message.success(
              this.editRow.type === 'add'
                ? this.$t('config-manager::operate-config::新增成功')
                : this.$t('config-manager::operate-config::编辑成功')
            )
            this.$emit('success')
            this.visible = false
          }
        }
      })
    },
    async getTeamTarget() {
      const { data } = await getTeamTarget({
        teamId: this.editRow.id,
        date: this.date,
      })
      if (data.code === this.$code) {
        this.form.teamId = data.data && data.data[0] && data.data[0].team.split('-').map(i => Number(i))
        this.getWorkers()
      }
    },
  },
  computed: {
    teamDataList() {
      const fn = arr => {
        return arr.map(item => {
          if (item.children && item.children.length) {
            fn(item.children)
          } else if (item.children) {
            delete item.children
          }
          return item
        })
      }
      return fn(this.$deepClone(this.teams))
    },
  },
  watch: {
    value(val) {
      this.visible = val
      if (val) {
        this.$refs.form && this.$refs.form.clearValidate()
        this.getTargetTreeUsers()
        if (this.editRow.type === 'edit') {
          this.getTeamTarget()
        }
      } else {
        this.form.teamId = ''
        this.form.target = ''
        this.workers = []
        this.$refs.form && this.$refs.form.clearValidate()
      }
    },
    visible(val) {
      this.$emit('input', val)
    },
  },
}
</script>

<style></style>
